module.exports = __webpack_public_path__ + "static/vi-c60f0454025150fcb47b1136ee715f2d.svg";